import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import images from 'assets/images';
import { Colors } from 'theme';
import logoImage from '../../../../assets/images/logo-branding-lg.jpg';

const Root = styled(Grid)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up('sm')]: {
    height: '100vh',
  },
}));

const ImageContainerColumn = styled(Grid)(({ theme }) => ({
  backgroundImage: `url("${images.loginBackImage}")`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'top center',
  minWidth: '72rem',
  maxWidth: '56.25%',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const OktaWidgetContainerColumn = styled(Grid)(({ theme }) => ({
  backgroundPosition: 'center',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minWidth: '56rem',
  maxWidth: '43.75%',
  padding: '4rem 0',
  boxShadow: 'none',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '100%',
    minWidth: 0,
    padding: theme.spacing(2),
    width: '100%',
  },
}));

const PaperDiv = styled('div')(({ theme }) => ({
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: Colors.white,
  height: 'calc(100vh - 8rem)',
  maxHeight: '86rem',
  maxWidth: '72rem',
  minHeight: '65rem',
  minWidth: '42rem',
  overflowY: 'auto',
  paddingBottom: '3.2rem',
  position: 'relative',
  width: 'calc(100% - 8rem)',
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    margin: '0 auto',
    maxWidth: '34.4rem',
    minHeight: '0',
    minWidth: '0',
    overflowY: 'visible',
    paddingBottom: 0,
    width: '100%',
  },
}));

const OktaSignInDiv = styled('div')(({ theme }) => ({
  width: '100%',
  '& #okta-sign-in': {
    backgroundColor: 'transparent !important',
    border: '0',
    fontSize: '1.5rem !important',
    marginTop: '0 !important',
    minWidth: '42rem !important',
    width: '100% !important',
    maxWidth: '100%',
  },
  '#okta-sign-in .password-expired .auth-footer .goto': {
    float: 'left',
  },
  '& #okta-sign-in.auth-container .okta-form-title': {
    textAlign: 'left',
    fontSize: '2.8rem',
    color: theme.palette.mode === 'dark' ? theme.palette.neutral.main : theme.palette.text.primary,
    paddingTop: '6rem',
    paddingRight: '21rem',
    paddingBottom: '3.2rem',
    minHeight: '14.8rem !important',
    height: 'auto !important',
    boxSizing: 'border-box',
    backgroundImage: `url(${logoImage}) !important`,
    backgroundPosition: 'right 2.4rem center !important',
    backgroundRepeat: 'no-repeat !important',
    backgroundSize: '18rem auto !important',
  },
  '& #okta-sign-in .social-auth-microsoft-button': {
    position: 'flex',
    borderRadius: '2px',
    borderColor: theme.palette.primary.main,
    display: 'block',
    color: `${theme.palette.primary.main} !important`, // text color important?
    textAlign: 'center !important',
    background: `url(${images.microsoftIcon}) 1.5rem no-repeat !important`,
    fontWeight: '600 !important',
    '&:hover': {
      textDecoration: 'none !important',
      backgroundColor: `${Colors.alphaWhite} !important`,
    },
  },
  '& #okta-sign-in.auth-container .button-primary': {
    borderColor: theme.palette.primary.main,
    color: Colors.white,
    background: theme.palette.primary.main,
    position: 'flex',
    display: 'block',
  },
  '& #okta-sign-in.auth-container .link:active, #okta-sign-in.auth-container .link:hover, #okta-sign-in.auth-container .link:link, #okta-sign-in.auth-container .link:visited':
    {
      fontSize: '1.6rem',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: '-0.1px',
      textDecoration: 'underline',
      color: theme.palette.primary.main,
    },
  '& #okta-sign-in.auth-container .o-form-head': {
    textAlign: 'left',
  },
  '& #okta-sign-in .o-form-head+.o-form-explain': {
    textAlign: 'left',
  },
  '& #okta-sign-in.auth-container .okta-sign-in-header': {
    display: 'none',
  },
  '& #okta-sign-in.auth-container': {
    height: 'auto',
    minHeight: '0',
    overflow: 'visible',
    paddingTop: '2rem',
  },
  // Enables logo visibility
  '& #okta-sign-in.auth-container.main-container': {
    width: '100%',
    boxShadow: 'none',
  },
  '& #okta-sign-in input:-webkit-autofill, & #okta-sign-in input:-webkit-autofill:hover, & #okta-sign-in input:-webkit-autofill:focus, & #okta-sign-in textarea:-webkit-autofill, & #okta-sign-in textarea:-webkit-autofill:hover, & #okta-sign-in textarea:-webkit-autofill:focus, & #okta-sign-in select:-webkit-autofill, & #okta-sign-in select:-webkit-autofill:hover, & #okta-sign-in select:-webkit-autofill:focus':
    {
      WebkitTextFillColor: theme.palette.text.primary,
      caretColor: theme.palette.text.primary,
      WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.background.paper} inset`,
      transition: 'background-color 9999s ease-in-out 0s',
    },
  [theme.breakpoints.down('sm')]: {
    '& #okta-sign-in': {
      fontSize: '1.3rem !important',
      marginTop: '0 !important',
      maxWidth: '100% !important',
      minWidth: '0 !important',
      width: '100% !important',
    },
    '& #okta-sign-in.auth-container': {
      height: 'auto',
      maxWidth: '100% !important',
      minHeight: '0',
      paddingTop: '0',
      width: '100% !important',
    },
    '& #okta-sign-in.auth-container.main-container': {
      width: '100% !important',
    },
    '& #okta-sign-in.auth-container .okta-form-title': {
      backgroundPosition: 'center 1.6rem !important',
      backgroundSize: '14rem auto !important',
      minHeight: '15.2rem !important',
      paddingBottom: '1.8rem',
      paddingRight: '0',
      paddingTop: '10rem',
      textAlign: 'center',
    },
    '& #okta-sign-in .o-form, & #okta-sign-in .o-form-content, & #okta-sign-in .o-form-fieldset, & #okta-sign-in .o-form-input, & #okta-sign-in.auth-container .button':
      {
        boxSizing: 'border-box',
        maxWidth: '100% !important',
        width: '100% !important',
      },
    '& #okta-sign-in input': {
      boxSizing: 'border-box',
      maxWidth: '100% !important',
    },
  },
}));

const LegalLinksContainer = styled(Grid)(({ theme }) => ({
  display: 'grid',
  margin: 'auto auto 0',
  padding: '0 5.6rem',
  textAlign: 'center',
  gridTemplateColumns: 'repeat(2, 1fr)',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    columnGap: theme.spacing(2),
    margin: `${theme.spacing(2)} auto 0`,
    maxWidth: '34.4rem',
    padding: 0,
    width: '100%',
  },
}));

const TermsAndConditionsLink = styled(Link)(({ theme }) => ({
  fontWeight: 'normal',
  display: 'flex',
  color: theme.palette.primary.main,
  fontSize: '1.6rem',
  textAlign: 'center',
  float: 'left',
  justifyContent: 'center',
}));

const PrivacyPolicyLink = styled(Link)(({ theme }) => ({
  fontWeight: 'normal',
  display: 'flex',
  color: theme.palette.primary.main,
  fontSize: '1.6rem',
  justifyContent: 'center',
  textAlign: 'center',
  float: 'right',
}));

export {
  Root,
  ImageContainerColumn,
  OktaWidgetContainerColumn,
  PaperDiv,
  OktaSignInDiv,
  LegalLinksContainer,
  TermsAndConditionsLink,
  PrivacyPolicyLink,
};
